var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 2C16.54 2 4 14.54 4 30c0 5.445 1.676 10.512 4.783 14.724C6.303 54.006 4.86 59.178 4.86 59.178S10.454 57.522 14.9 56.195C19.168 58.239 23.87 59.478 28 59.478 43.46 59.478 56 46.938 56 31.478 56 16.019 43.46 2 28 2zm0 4c12.958 0 23.478 10.52 23.478 23.478 0 12.957-10.52 23.478-23.478 23.478-4.262 0-8.314-1.135-11.805-3.112C13.73 56.96 7.94 58.76 7.94 58.76s1.742-5.405 2.914-9.888C8.252 43.092 6.522 37.629 6.522 33.478 6.522 19.52 17.042 10 28 10z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.1f96400efe88e0f8e66af6f4ee5e4198.svg";
export { ForwardRef as ReactComponent };